import { parse } from 'query-string';

export const getUrlFilter = (location: any) => (key: string) => {
  const parsedSearch = parse(location.search) as { [key: string]: string };
  return parsedSearch[`${key}`];
};
